import type { PropsWithChildren } from 'react';
import { useTheme } from 'styled-components';

const OnboardingLayout = ({ children }: PropsWithChildren) => {
  const theme = useTheme();
  return <theme.layout.OnboardingLayout>{children}</theme.layout.OnboardingLayout>;
};

export default OnboardingLayout;
